import { render, staticRenderFns } from "./CompanyPhilosophyScreen.vue?vue&type=template&id=6a8ee4e2&scoped=true&"
import script from "./CompanyPhilosophyScreen.vue?vue&type=script&lang=js&"
export * from "./CompanyPhilosophyScreen.vue?vue&type=script&lang=js&"
import style0 from "./CompanyPhilosophyScreen.vue?vue&type=style&index=0&id=6a8ee4e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8ee4e2",
  null
  
)

export default component.exports